import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  template: `
    <div class="form-group">
      <label for="{{ id }}" class="form-label">{{ label }}</label>
      <div class="input-group">
        <label class="input-group-addon range-label">{{ value * mult }}%</label>
        <input type="range" id="{{ id }}" min="{{ min }}" max="{{ max }}" step="{{ step }}" class="form-control slider" value="75" [(ngModel)]="value" >
      </div>
    </div>
  `,
  styles: [
    `
      .form-control {
        border: none !important;
        margin-top: 8px;
      }
      .input-group-addon {
        border: none;
        color:  var(--primary);
        font-size: smaller;
        background: none;
      }
      .slider {
        -webkit-appearance: none;
        width: 100%;
        height: 3px;
        border-radius: 3px;
        outline: none;
        opacity: 0.7;
        -webkit-transition: .2s;
        transition: opacity .2s;
        padding: 3px;
      }
      
      .slider:hover {
        opacity: 1;
      }
      
      .slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background-color: var(--primary);
        cursor: pointer;
      }
      
      .slider::-moz-range-thumb {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background-color: var(--primary);
        cursor: pointer;
      }
    `
  ],
  selector: 'input-slider'
})
export class InputSliderComponent implements OnInit, OnDestroy {

  @Input('label') public label: string;
  @Input('min') public min: number = 0;
  @Input('max') public max: number = 100;
  @Input('step') public step: number = 1;
  @Input('mult') public mult: number = 1;
  
  public id: string;

  @Output() public valueChange: EventEmitter<string> = new EventEmitter<string>();
  private _value: string;
  @Input('value') public get value() { return this._value; }
  public set value(v: string) {
    this._value = v;
    this.valueChange.emit(this._value);
  }

  constructor() {}

  ngOnInit() {
    this.id = '_id_' + Math.floor(Math.random() * 999 + 100);
  }

  ngOnDestroy(): void {}

}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/common-livee/input-slider.component.ts